import React from "react";

const LineBackground = ({ canvasSize, dimensions }) => {
  const lineY = canvasSize.height / 2;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
      }}
    >
      {/* Center line */}
      <div
        style={{
          position: "absolute",
          top: lineY,
          left: 0,
          width: "100%",
          height: 2,
          background: "linear-gradient(to right, #595959, #8c8c8c)",
          borderRadius: 2,
          boxShadow: "0 0 6px rgba(89, 89, 89, 0.35)",
        }}
      />

      {/* Tick mark at 0% */}
      <div
        style={{
          position: "absolute",
          top: lineY - 6,
          left: 0,
          width: 1,
          height: 12,
          backgroundColor: "#595959",
        }}
      />
      {/* Tick mark at 50% */}
      <div
        style={{
          position: "absolute",
          top: lineY - 6,
          left: canvasSize.width / 2,
          width: 1,
          height: 12,
          backgroundColor: "#595959",
        }}
      />
      {/* Tick mark at 100% */}
      <div
        style={{
          position: "absolute",
          top: lineY - 6,
          left: canvasSize.width - 1,
          width: 1,
          height: 12,
          backgroundColor: "#595959",
        }}
      />

      {/* Distance labels */}
      <div
        style={{
          position: "absolute",
          top: lineY + 8,
          left: 0,
          width: `${canvasSize.width}px`,
          fontSize: "12px",
          color: "#666",
          zIndex: 10,
          pointerEvents: "none",
        }}
      >
        <span style={{ position: "absolute", left: 0, transform: "translateX(-50%)" }}>
          0m
        </span>
        <span style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
          {(dimensions.width / 2).toFixed(1)}m
        </span>
        <span style={{ position: "absolute", right: 0, transform: "translateX(50%)" }}>
          {dimensions.width}m
        </span>
      </div>
    </div>
  );
};

export default LineBackground;
